import GenericUsers from './GenericUsers';

export const PAGE_USERS = '/users';

export default GenericUsers;
